import React from 'react';
import {Link} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";

const PageNotAllowed = ({ error, resetErrorBoundary, redirect, message = 'You don\'t have the appropriate permissions for this page.', btnText }) => {
    const {auth, appropriate} = useAuth();

    if (!auth) return null;

    return (
        <div className="flex items-center justify-center">
            <div className="page-error" style={TB.createStyledCircle(TB.config("color.info"), 0.1)}>

                <div className="white-panel">
                    <h1>403</h1>

                    <h3>Access Forbidden</h3>

                    <p>{message}</p>

                    <Link
                        to={redirect || appropriate || '/dashboard'}
                        replace={true}
                        className="btn btn-primary mt-2">
                        {btnText || "Return to dashboard"}
                    </Link>
                </div>

            </div>
        </div>
    );
};

PageNotAllowed.propTypes = {

};

export default PageNotAllowed;